<template>
  <div class="news">
    <banner title="案例展示" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 1}"
            @click="newstype = 1"
          >
            <span>9类锂电池危险品Tir直达</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 2}"
            @click="newstype = 2 "
          >
            <span>普货TIR直达</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 3}"
            @click="newstype = 3 "
          >
            <span>普货转关运输</span>
          </div>
        </div>
        <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <p class="item-list-content">{{item.Content}}</p>
          </div>
        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <div class="item-img" v-lazy:background-image="item.Img"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import img1 from '@/assets/img/case1.png'
import img2 from '@/assets/img/case2.png'
import img3 from '@/assets/img/case3.png'
export default {
  name: "ShowCase",
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      newsList: [
        {
          Content:' 依托国际 TIR 运输公约，提供“一车到底、口岸不换装、过境海关不查验”的跨境直达服务，从广州出发、阿拉山口出境，直达俄罗斯莫斯科，全程8000公里，耗时12天。',
          Img:img1
        }
      ],
      newstype: 1
    };
  },
  methods: {
  },
  mounted() {

  },
  watch: {
    newstype(type) {
      window.console.log(type);
      if(type==1) {
        this.newsList = [
        {
          Content:' 依托国际 TIR 运输公约，提供“一车到底、口岸不换装、过境海关不查验”的跨境直达服务，从广州出发、阿拉山口出境，直达俄罗斯莫斯科，全程8000公里，耗时12天。',
          Img:img1
        }
        
        ]
      }
      if(type==2) {
        this.newsList = [
        {
          Content:' 依托国际 TIR 运输公约，提供“一车到底、口岸不换装、过境海关不查验”的跨境直达服务，从深圳出发、霍尔果斯口岸出境，直达俄罗斯莫斯科，全程8000公里，耗时12天。',
          Img:img2
        }
        
        ]
      }
      if(type==3) {
        this.newsList = [
        {
          Content:'依托国际道路运输协定，提供“口岸换车、转关”的跨境门到门服务，从江苏出发、伊尔克什坦口岸仓出境，直达吉尔吉斯斯坦比什凯克，全程5600公里，耗时7天。',
          Img:img3
        }
        
        ]
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.item-list-content {
  padding: 0 10px;
  font-size: 16px;
}
.news {
  width: 100%;
  height: 100%;
  background: url(../assets/img/b3.jpg) repeat center;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 80%;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;

      .content-nav {
        width: 830px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 100%;
          height: 500px;
          margin: 10px 10px;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 100%;
            height:100%;
            background-color: #fff;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>